export const tr = {
    'add-entity': 'Ekle',
    'agency-clients': 'Ajansın müşteri listesi',
    'all-clients': 'Tüm müşteriler ',
    campaigns: 'Kampanyalar',
    'client-representatives': 'Kayıtlı temsilciler',
    creatives: 'Akıllı bannerlar için kreatifler',
    edit: 'Düzenleme',
    feeds: 'Beslemeler',
    info: 'Bilgi',
    'internationalization-interface': 'Yerelleştirme arayüzü',
    library: 'Arşivi',
    'minus-keywords-library': 'Negatif anahtar sözcük grupları',
    'mobile-apps': 'Mobil uygulamalar',
    'order-reports': 'Rapor oluşturma',
    'phrases-positions-monitoring': 'Sözcük gruplarına göre pozisyon değişikliklerini izleme',
    'price-packages-grid': 'Paketler',
    recommendations: 'Öneriler',
    reports: 'Raporlar',
    'retargeting-and-audiences': 'Hedef kitle seçme koşulları',
    'statistic-by-all-campaigns': 'Tüm kampanyalara göre istatistikler',
    'statistic-by-all-old-campaigns': 'Kredi bazında eski kampanyalara göre istatistikler',
    tools: 'Araçlar',
    'turbo-pages': 'Turbo Sayfa Sihirbazı',
    'upload-documents': 'Belgeleri yükle'
};
